import { SnackbarProvider, useSnackbar } from 'notistack';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FaFilePdf } from 'react-icons/fa';
import Axios from "axios";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Input from "../../../components/Input";
import Navbar from "../../../components/Navbar";
import React from "react";
import Select from "../../../components/select";
import SubmitButton from "../../../components/Button";
import moment from "moment";
import style from "./RelatorioSaida.module.css"
import { useStepContext } from "@mui/material";
import JC7Logo from "./Logo-JC7.png";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { FaFileExcel } from 'react-icons/fa';

const ExcelJS = require('exceljs');

const RelatorioSaida = () => {

    useEffect(() => {
        getOp();
        getAutos();
        getOperacoes();
        getPesoLiquido();
        getDocumentos();
        getDocumentosENTRADA();
        getNavios();
        getPedidosByOperacao(); // << NOVO
    }, [])

    const { id } = useParams();
    const [navioslist, setNaviosList] = useState([])
    const [busca, setBusca] = useState("");
    const usuario = JSON.parse(localStorage.getItem("user_token")).id;
    const [operacoes, setOperacoes] = useState([]);
    const [filter, setFilter] = useState("");
    const [filterType, setFilterType] = useState("NOME_MOTORISTA");
    const [autos, setAutos] = useState([]);
    const [pesoliquido, setPesoLiquido] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [documentosENTRADA, setDocumentosENTRADA] = useState([]);
    const [navios, setNavios] = useState([]);
    const [pedidosOp, setPedidosOp] = useState([]); // << NOVO
    const JC7LogoBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAADnCAYAAADo46QLAAAAAXNSR0Ifw8PDw8GgBeEL38PDw8PBoAXhC9/Dw8PDw8Fj1EPn/AQMIrw/LW3EwAAAAAElFTkSuQmCC';
    const navigate = useNavigate();

    const getOp = () => {
        Axios.get('https://portal.jc7transportes.com.br/api/relatorios/operacoes').then((response) => {
            setNaviosList(response.data)
        });
    }

    const getDate = () => {
        const date = new Date()
        date.setHours(date.getHours() - 3)
        return (date.toISOString().slice(0, 19).replace('T', ' '))
    }

    const { enqueueSnackbar } = useSnackbar();

    const showAlert = (txt, variant) => {
        enqueueSnackbar(txt, { variant: variant });
    }

    const getOperacoes = () => {
        Axios.get(`https://portal.jc7transportes.com.br/api/periodo/carregamento/saida/${id}`).then((response) => {
            console.log(response.data);
            setOperacoes(response.data);
        }).catch((error) => {
            console.error("Erro ao buscar operações:", error);
        });
    }

    const getAutos = () => {
        Axios.get(`https://portal.jc7transportes.com.br/api/relatorio/autos/saida/${id}`).then((response) => {
            console.log(response.data);
            setAutos(response.data);
        }).catch((error) => {
            console.error("Erro ao buscar autos:", error);
        });
    }

    const getPesoLiquido = () => {
        Axios.get(`https://portal.jc7transportes.com.br/api/relatorio/pesoliquido/saida/${id}`).then((response) => {
            console.log(response.data);
            setPesoLiquido(response.data);
        }).catch((error) => {
            console.error("Erro ao buscar Peso Liquido:", error);
        });
    }

    const getDocumentos = () => {
        Axios.get(`https://portal.jc7transportes.com.br/api/relatorio/documentos/saida/${id}`).then((response) => {
            console.log(response.data);
            setDocumentos(response.data);
        }).catch((error) => {
            console.error("Erro ao buscar os Documentos:", error);
        });
    }

    const getDocumentosENTRADA = () => {
        Axios.get(`https://portal.jc7transportes.com.br/api/relatorio/documentos/saida/manifestado/${id}`).then((response) => {
            console.log(response.data);
            setDocumentosENTRADA(response.data);
        }).catch((error) => {
            console.error("Erro ao buscar os Documentos:", error);
        });
    }

    const getNavios = () => {
        Axios.get(`https://portal.jc7transportes.com.br/api/relatorio/navios/${id}`).then((response) => {
            console.log(response.data);
            setNavios(response.data);
        }).catch((error) => {
            console.error("Erro ao buscar os Navios:", error);
        });
    }

    // ===== NOVO: Buscar pedidos (com manifestado) por operação =====
    const getPedidosByOperacao = () => {
        Axios.get(`https://portal.jc7transportes.com.br/api/pedido/operacao/${id}`)
            .then((response) => {
                setPedidosOp(response.data || []);
            })
            .catch((error) => {
                console.error("Erro ao buscar pedidos por operação:", error);
            });
    };

    // ===== NOVO: Somatório do Peso Líquido por pedido (NR_PEDIDO) a partir de operacoes =====
    const saidoPorPedido = React.useMemo(() => {
        const map = {};
        for (const o of operacoes) {
            const ped = o?.NR_PEDIDO;
            if (!ped) continue;
            const pl = (o.PESO_BRUTO && o.PESO_TARA) ? (o.PESO_BRUTO - o.PESO_TARA) : 0;
            map[ped] = (map[ped] || 0) + pl;
        }
        return map;
    }, [operacoes]);

    const generatePdf = (carregamento) => {
        const pdf = new jsPDF();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const logoWidth = 30;
        const logoHeight = 30;
        const logoMarginRight = 10; // Margem da direita para o logo
        const column1StartX = 10;
        const column2StartX = pageWidth / 2;
        const columnWidth = (pageWidth / 2) - 20;

        // Definindo Helvetica como fonte
        pdf.setFont('Helvetica', 'bold');

        // Cabeçalho
        pdf.setFontSize(15);
        pdf.text("Armazém JC7", 10, 15);
        pdf.setFont('Helvetica', 'normal');
        pdf.setFontSize(13);
        pdf.text("Rodovia Padre Manoel da Nobrega N°83103", 10, 20);
        pdf.text("(13) 3406-1041", 10, 25);
        pdf.addImage(JC7Logo, 'PNG', pageWidth - logoWidth - logoMarginRight, 10, logoWidth, logoHeight);

        // Título de Bilhete de Pesagem
        pdf.setFontSize(16);
        const bilheteTitle = `CARGA \nBILHETE DE PESAGEM N° ${carregamento.ID_CARREGAMENTO}`;
        pdf.text(bilheteTitle, pageWidth / 2, 40, 'center');

        // Linha divisória
        pdf.setDrawColor(0);
        pdf.line(10, 45, pageWidth - 10, 45);

        let startY = 50; // Iniciar a posição Y para as informações

        // Motorista
        let motoristaDetailsStartY = startY;
        let motoristaDetailsEndY = addSectionWithBoxMotorista(pdf, "Motorista", formatMotoristaDetails(carregamento), column1StartX, motoristaDetailsStartY, columnWidth, false);

        // Veículo
        let placaDetailsStartY = startY;
        let placaDetailsEndY = addSectionWithBoxVeiculo(pdf, "Veículo", formatPlacaDetails(carregamento), column2StartX, placaDetailsStartY, columnWidth, false);

        // Navio e Produto em duas colunas
        startY = Math.max(motoristaDetailsEndY, placaDetailsEndY) + 1;
        let navioSectionY = addSectionWithBox(pdf, "Navio", carregamento.NOME_NAVIO, column1StartX, startY, columnWidth, true);
        let produtoSectionY = addSectionWithBox(pdf, "Produto", carregamento.PRODUTO, column2StartX, startY, columnWidth, true);

        // Cliente e Transportadora em duas colunas
        startY = Math.max(navioSectionY, produtoSectionY) + 1;
        let clientSectionY = addSectionWithBox(pdf, "Cliente", carregamento.NOME_REDUZIDO, column1StartX, startY, columnWidth, true);
        let transportadoraSectionY = addSectionWithBox(pdf, "Transportadora", carregamento.NOME_REDUZIDO_TRANSP, column2StartX, startY, columnWidth, true);

        // DI e Pedido em duas colunas
        startY = Math.max(clientSectionY, transportadoraSectionY) + 1;
        let diSectionY = addSectionWithBoxDI(pdf, "DI", carregamento.NUMERO_DOC, column1StartX, startY, columnWidth, true);

        // Inicializa pedidoSectionY com diSectionY caso a seção "Quantidade de BIG BAG" não seja adicionada
        let pedidoSectionY = diSectionY;

        // Verifica se QTDA_BIG_BAG e PESO_BIG_BAG possuem valores válidos
        if (carregamento.QTDA_BIG_BAG && carregamento.PESO_BIG_BAG) {
            pedidoSectionY = addSectionWithBox(
                pdf,
                "Quantidade de BIG BAG",
                `${carregamento.QTDA_BIG_BAG} Unidades de ${carregamento.PESO_BIG_BAG.toLocaleString()} KG`,
                column2StartX,
                startY,
                columnWidth,
                true
            );
        } else {
            // Adiciona a seção OPERAÇÃO na coluna 2
            let operacaoSectionY = addSectionWithBox(
                pdf,
                "OPERAÇÃO",
                `GRANEL`,
                column2StartX,
                startY,
                columnWidth,
                true
            );
        }
        // Peso Bruto
        let placaBrutoDetailsStartY = pedidoSectionY + 1;
        let placaBrutoDetailsEndY = addSectionWithBox4(pdf, "Peso Bruto", formatPesoBrutoDetails(carregamento), column1StartX, placaBrutoDetailsStartY, columnWidth, false);

        // Peso Tara
        let pesoTaraDetailsStartY = diSectionY + 1;
        let pesoTaraDetailsEndY = addSectionWithBox4(pdf, "Peso Tara", formatPesoTaraDetails(carregamento), column2StartX, pesoTaraDetailsStartY, columnWidth, false);

        // Adiciona a seção "Diferença de Peso"
        let diferencaPesoDetailsStartY = placaBrutoDetailsEndY + 1;
        let diferencaPesoDetailsEndY = addSectionWithBoxOp(pdf, "Tipo de Operação", ("SAÍDA DE " + carregamento.PRODUTO), column1StartX, diferencaPesoDetailsStartY, columnWidth, false);

        // Peso Líquido
        let pesoLiquidoDetailsStartY = pesoTaraDetailsEndY + 1;
        let pesoLiquidoDetailsEndY = addSectionWithBoxPesos(pdf, "Peso Líquido", formatPesoLiquidoDetails(carregamento), column2StartX, pesoLiquidoDetailsStartY, columnWidth, false);

        // Preparando para seção de Assinaturas
        const observationsHeight = 20; // Altura da caixa de observações (de uma seção anterior, por exemplo)
        const observationsStartY = pageHeight - 80; // Posição Y inicial para observações (ajuste conforme necessário)
        const signatureSectionStartY = observationsStartY + observationsHeight + 5; // Espaço após a seção de observações
        const signatureSectionHeight = 40; // Altura da seção de assinaturas

        // Assinaturas em duas colunas
        addSignatureSection(pdf, " Assinatura da Empresa", " JC7 Terminais Portuários e Transportes Ltda", column1StartX, signatureSectionStartY, columnWidth);
        addSignatureSectionMotorista(pdf, " Assinatura do Motorista", " " + carregamento.NOME_MOTORISTA, formatarCPF(carregamento.CPF_MOTORISTA), column2StartX, signatureSectionStartY, columnWidth);

        // Linha divisória
        pdf.setDrawColor(0);
        pdf.line(10, 283, pageWidth - 10, 283);

        // Footer
        pdf.setFontSize(9);
        pdf.text("Sistema de Pesagem - CONFIANTEC BALANÇAS\nwww.jc7terminais.com.br", pageWidth / 2, pageHeight - 10, 'center');

        // Salvar o PDF
        pdf.save(`Carregamento-${carregamento.ID_CARREGAMENTO}.pdf`);
    };

    function addSignatureSection(pdf, title, content, startX, startY, width) {
        pdf.setFontSize(10);
        pdf.text(`${title}:`, startX, startY);
        pdf.text(content, startX, startY + 8);
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2); // Reduzindo a grossura do contorno para 0.2
        pdf.rect(startX, startY - 5, width, 40, 'S');
    }

    function addSignatureSectionMotorista(pdf, title, name, cpf, startX, startY, width) {
        const lineHeight = 10; // Altura entre linhas
        pdf.setFontSize(10); // Tamanho da fonte para o título
        pdf.text(`${title}:`, startX, startY); // Escreve o título

        pdf.setFont('Helvetica', 'normal'); // Define a fonte para normal para o nome
        pdf.setFontSize(9); // Tamanho da fonte para o nome
        pdf.text(name, startX, startY + 5); // Escreve o nome do motorista na linha abaixo do título

        pdf.setFontSize(9); // Tamanho da fonte para o CPF
        pdf.text(` CPF: ${cpf}`, startX, startY + 9); // Escreve o CPF na próxima linha

        // Desenha uma caixa ao redor da seção de assinatura
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2); // Define a espessura da linha
        pdf.rect(startX, startY - 5, width, 3 * lineHeight + 10, 'S'); // Ajusta o tamanho da caixa para acomodar todo o texto
    }

    function formatPlacaDetails(carregamento) {
        return `Cavalo: ${carregamento.PLACA_CAVALO}      Carreta: ${carregamento.PLACA_CARRETA || '----------'}\nCarreta 2: ${carregamento.PLACA_CARRETA2 || '----------'}      Carreta 3: ${carregamento.PLACA_CARRETA3 || '----------'}`;
    }

    function formatMotoristaDetails(carregamento) {
        const cpfFormatado = formatarCPF(carregamento.CPF_MOTORISTA); // Supondo que formatarCPF retorne o CPF formatado.
        return `${carregamento.NOME_MOTORISTA}\n CPF: ${cpfFormatado}`;
    }

    function formatarCPF(cpf) {
        return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }

    function formatPesoBrutoDetails(carregamento) {
        let dataBrutoString = "Aguardando";
        if (carregamento.DATA_BRUTO) {
            const dataBruto = new Date(carregamento.DATA_BRUTO);
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'America/Sao_Paulo' };
            dataBrutoString = dataBruto.toLocaleString('pt-BR', options);
        }
        const pesoBruto = carregamento.PESO_BRUTO ? carregamento.PESO_BRUTO.toLocaleString('pt-BR') : "0";
        return `Data e Hora: ${dataBrutoString}\nPESO: ${pesoBruto} KG`;
    }

    function formatPesoTaraDetails(carregamento) {
        let dataTaraString = "Aguardando";
        if (carregamento.DATA_TARA) {
            const dataTara = new Date(carregamento.DATA_TARA);
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'America/Sao_Paulo' };
            dataTaraString = dataTara.toLocaleString('pt-BR', options);
        }
        const pesoTara = carregamento.PESO_TARA ? carregamento.PESO_TARA.toLocaleString('pt-BR') : "0";
        return `Data e Hora: ${dataTaraString}\nPESO: ${pesoTara} KG`;
    }

    function formatPesoLiquidoDetails(carregamento) {
        const pesoLiquido = carregamento.PESO_BRUTO && carregamento.PESO_TARA ? carregamento.PESO_BRUTO - carregamento.PESO_TARA : 0;
        const pesoLiquidoFormatado = pesoLiquido.toLocaleString('pt-BR');
        let dataPesoBrutoString = "Aguardando";
        if (carregamento.DATA_BRUTO) {
            const dataPesoBruto = new Date(carregamento.DATA_BRUTO);
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'America/Sao_Paulo' };
            dataPesoBrutoString = dataPesoBruto.toLocaleString('pt-BR', options);
        }
        return `${pesoLiquidoFormatado} KG`;
    }

    function addSectionWithBoxDI(pdf, title, content, startX, startY, width, boldContent = false) {
        const cornerRadius = 2;
        const lineHeight = 6;
        const sectionHeight = 18;

        pdf.setFontSize(11);
        pdf.setFont('Helvetica', 'normal');

        const titleX = startX + 2;
        pdf.text(`${title}:`, titleX, startY + lineHeight);

        pdf.setFont('Helvetica', 'bold');
        pdf.setFontSize(16);

        const contentWidth = pdf.getStringUnitWidth(content) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const contentX = startX + (width - contentWidth) / 2;

        pdf.text(content, contentX, startY + lineHeight * 2.5);

        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2);
        pdf.roundedRect(startX, startY, width, sectionHeight, cornerRadius, cornerRadius, 'S');
        return startY + sectionHeight + lineHeight;
    }

    function addSectionWithBox(pdf, title, content, startX, startY, width, boldContent = false) {
        const cornerRadius = 2;
        const lineHeight = 6;
        const sectionHeight = 18;

        pdf.setFontSize(11);
        pdf.setFont('Helvetica', 'normal');

        const titleX = startX + 2;
        pdf.text(`${title}:`, titleX, startY + lineHeight);

        pdf.setFont('Helvetica', 'bold');
        pdf.setFontSize(12);

        const contentWidth = pdf.getStringUnitWidth(content) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const contentX = startX + (width - contentWidth) / 2;

        pdf.text(content, contentX, startY + lineHeight * 2.5);

        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2);
        pdf.roundedRect(startX, startY, width, sectionHeight, cornerRadius, cornerRadius, 'S');
        return startY + sectionHeight + lineHeight;
    }

    function addSectionWithBoxMotorista(pdf, title, content, startX, startY, width, boldContent = false) {
        const cornerRadius = 2;
        const lineHeight = 6;
        const sectionHeight = 23;

        pdf.setFontSize(11);
        pdf.setFont('Helvetica', 'normal');

        const titleX = startX + 2;
        pdf.text(`${title}:`, titleX, startY + lineHeight);

        pdf.setFont('Helvetica', 'bold');
        pdf.setFontSize(12);

        const contentWidth = pdf.getStringUnitWidth(content) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const contentX = startX + (width - contentWidth) / 2 + 20;

        pdf.text(content, contentX, startY + lineHeight * 2.5);

        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2);
        pdf.roundedRect(startX, startY, width, sectionHeight, cornerRadius, cornerRadius, 'S');
        return startY + sectionHeight + lineHeight;
    }

    function addSectionWithBoxVeiculo(pdf, title, content, startX, startY, width, boldContent = false) {
        const cornerRadius = 2;
        const lineHeight = 6;
        const sectionHeight = 23;

        pdf.setFontSize(11);
        pdf.setFont('Helvetica', 'normal');

        const titleX = startX + 1;
        pdf.text(`${title}:`, titleX, startY + lineHeight);

        pdf.setFont('Helvetica', 'bold');
        pdf.setFontSize(11);

        const contentWidth = pdf.getStringUnitWidth(content) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const contentX = startX + (width - contentWidth) / 2 + 39;

        pdf.text(content, contentX, startY + lineHeight * 2.5);

        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2);
        pdf.roundedRect(startX, startY, width, sectionHeight, cornerRadius, cornerRadius, 'S');
        return startY + sectionHeight + lineHeight;
    }

    function addSectionWithBox4(pdf, title, content, startX, startY, width, boldContent = false) {
        const cornerRadius = 2;
        const lineHeight = 6;
        const sectionHeight = 25;

        pdf.setFontSize(11);
        pdf.setFont('Helvetica', 'normal');

        const titleX = startX + 2;
        pdf.text(`${title}:`, titleX, startY + lineHeight);

        pdf.setFont('Helvetica', 'bold');
        pdf.setFontSize(12);

        const contentWidth = pdf.getStringUnitWidth(content) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const contentX = startX + (width - contentWidth) / 2 + 16;

        pdf.text(content, contentX, startY + lineHeight * 2.5);

        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2);
        pdf.roundedRect(startX, startY, width, sectionHeight, cornerRadius, cornerRadius, 'S');
        return startY + sectionHeight + lineHeight;
    }

    function addSectionWithBoxOp(pdf, title, content, startX, startY, width, boldContent = false) {
        const cornerRadius = 2;
        const lineHeight = 6;
        const sectionHeight = 20;

        pdf.setFontSize(10);
        pdf.setFont('Helvetica', 'normal');

        const titleX = startX + 2;
        pdf.text(`${title}:`, titleX, startY + lineHeight);

        pdf.setFont('Helvetica', 'bold');
        pdf.setFontSize(12);

        const contentWidth = pdf.getStringUnitWidth(content) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const contentX = startX + (width - contentWidth) / 2;

        pdf.text(content, contentX, startY + lineHeight * 2.5);

        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2);
        pdf.roundedRect(startX, startY, width, sectionHeight, cornerRadius, cornerRadius, 'S');
        return startY + sectionHeight + lineHeight;
    }

    function addSectionWithBoxPesos(pdf, title, content, startX, startY, width, boldContent = false) {
        const cornerRadius = 2;
        const lineHeight = 6;
        const sectionHeight = 20;

        pdf.setFontSize(10);
        pdf.setFont('Helvetica', 'normal');

        const titleX = startX + 2;
        pdf.text(`${title}:`, titleX, startY + lineHeight);

        pdf.setFont('Helvetica', 'bold');
        pdf.setFontSize(19);

        const contentWidth = pdf.getStringUnitWidth(content) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const contentX = startX + (width - contentWidth) / 2;

        pdf.text(content, contentX, startY + lineHeight * 2.5);

        pdf.setDrawColor(0);
        pdf.setLineWidth(0.2);
        pdf.roundedRect(startX, startY, width, sectionHeight, cornerRadius, cornerRadius, 'S');
        return startY + sectionHeight + lineHeight;
    }

const exportToExcel = async (apiData) => {
  try {
    // Filtra fora STATUS_CARREG = 7 (aceita number ou string)
    const filtered = (apiData || []).filter(
      (it) => Number(it?.STATUS_CARREG) !== 7
    );

    if (!filtered || filtered.length === 0) {
      showAlert("Não há dados para exportar (todos filtrados).", "warning");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data");

    const safe = (v) => (v === null || v === undefined || v === "" ? "---" : v);

    // --- LOOKUPS de destino ---
    // 1) Por Pedido (se houver em pedidosOp)
    const destinoPorPedido = {};
    if (Array.isArray(pedidosOp)) {
      for (const p of pedidosOp) {
        if (p?.NR_PEDIDO && !destinoPorPedido[p.NR_PEDIDO]) {
          destinoPorPedido[p.NR_PEDIDO] = p?.DESTINOS || "---";
        }
      }
    }
    // 2) Por DI (se houver em documentosENTRADA)
    const destinoPorDI = {};
    if (Array.isArray(documentosENTRADA)) {
      for (const d of documentosENTRADA) {
        if (d?.NUMERO_DOC && !destinoPorDI[d.NUMERO_DOC]) {
          destinoPorDI[d.NUMERO_DOC] = d?.DESTINOS || "---";
        }
      }
    }

    const headers = [
      { header: "ID Carregamento", key: "ID_CARREGAMENTO" },
      { header: "Placa do Cavalo", key: "PLACA_CAVALO" },
      { header: "Peso Tara (kg)", key: "PESO_TARA" },
      { header: "Data Tara", key: "DATA_TARA" },
      { header: "Peso Bruto (kg)", key: "PESO_BRUTO" },
      { header: "Data Bruto", key: "DATA_BRUTO" },
      { header: "Número Lacre", key: "NUMERO_LACRE" },
      { header: "Número Container", key: "NUMERO_CONTEINER" },
      { header: "Peso Líquido", key: "PESO_LIQUIDO" },
      { header: "DI", key: "NUMERO_DOC" },
      { header: "Pedido - Destino", key: "PEDIDO_DESTINO" }, // depois de DI
      { header: "Motorista", key: "NOME_MOTORISTA" },
      { header: "CPF Motorista", key: "CPF_MOTORISTA" },
      { header: "Navio", key: "NOME_NAVIO" },
      { header: "Produto", key: "PRODUTO" },
      { header: "Cliente", key: "NOME_CLIENTE" },
      { header: "Transportadora", key: "NOME_TRANSP" },
    ];

    worksheet.columns = headers.map((h) => ({
      header: h.header,
      key: h.key,
      width: 20,
    }));

    // Estilo do cabeçalho
    worksheet.getRow(1).height = 20;
    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "333333" } }; // cinza escuro
      cell.font = { bold: true, color: { argb: "FFFFFF" } }; // branco
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Linhas (já com a regra do Peso Líquido = 0 se BRUTO ou TARA forem null/0)
    filtered.forEach((item) => {
      const bruto = Number(item?.PESO_BRUTO ?? 0);
      const tara  = Number(item?.PESO_TARA  ?? 0);
      const liquidoCalc = (bruto > 0 && tara > 0) ? (bruto - tara) : 0;

      // resolve destino: tenta por pedido, depois por DI
      const destino =
        (item?.NR_PEDIDO ? destinoPorPedido[item.NR_PEDIDO] : undefined) ??
        (item?.NUMERO_DOC ? destinoPorDI[item.NUMERO_DOC] : undefined) ??
        "---";

      const rowData = {
        ID_CARREGAMENTO: safe(item?.ID_CARREGAMENTO),
        PLACA_CAVALO: safe(item?.PLACA_CAVALO),
        PESO_TARA: safe(item?.PESO_TARA),
        DATA_TARA: safe(item?.DATA_TARA),
        PESO_BRUTO: safe(item?.PESO_BRUTO),
        DATA_BRUTO: safe(item?.DATA_BRUTO),
        NUMERO_LACRE: safe(item?.NUMERO_LACRE),
        NUMERO_CONTEINER: safe(item?.NUMERO_CONTEINER),
        PESO_LIQUIDO: liquidoCalc,
        NUMERO_DOC: safe(item?.NUMERO_DOC),
        PEDIDO_DESTINO: item?.NR_PEDIDO ? `${item.NR_PEDIDO} - ${safe(destino)}` : "---",
        NOME_MOTORISTA: safe(item?.NOME_MOTORISTA),
        CPF_MOTORISTA: item?.CPF_MOTORISTA ? formatarCPF(item.CPF_MOTORISTA) : "---",
        NOME_NAVIO: safe(item?.NOME_NAVIO),
        PRODUTO: safe(item?.PRODUTO),
        NOME_CLIENTE: safe(item?.NOME_CLIENTE ?? item?.NOME_REDUZIDO ?? item?.NOME_CLIENTE_REDUZIDO),
        NOME_TRANSP: safe(item?.NOME_TRANSP ?? item?.NOME_REDUZIDO_TRANSP),
      };

      const row = worksheet.addRow(rowData);
      row.eachCell((cell) => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
    });

    // Largura automática controlada
    worksheet.columns.forEach((column) => {
      let maxLength = column.header ? String(column.header).length : 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const v = cell.value == null ? "" : String(cell.value);
        maxLength = Math.max(maxLength, v.length);
      });
      column.width = Math.min(Math.max(maxLength + 2, 12), 40);
    });

    // Nome do arquivo
    const navio = safe(filtered[0]?.NOME_NAVIO);
    const codOperacao = safe(filtered[0]?.COD_OPERACAO);
    const dynamicFileName = `${navio}-${codOperacao}-SAIDA.xlsx`;

    // Gerar e salvar
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    FileSaver.saveAs(blob, dynamicFileName);

    showAlert("Excel exportado com sucesso!", "success");
  } catch (err) {
    console.error(err);
    showAlert("Erro ao exportar Excel.", "error");
  }
};


    const formatarNomeMotorista = (nomeCompleto) => {
        const partesDoNome = nomeCompleto.split(" ");
        if (partesDoNome.length > 1) {
            return `${partesDoNome[0]} ${partesDoNome[partesDoNome.length - 1]}`;
        }
        return nomeCompleto;
    };

    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    };

    const handleFilterTypeChange = (e) => {
        setFilterType(e.target.value);
    };

    const filteredOperacoes = operacoes.filter((operacao) => {
        const filterLowerCase = filter.toLowerCase();
        switch (filterType) {
            case "NOME_MOTORISTA":
                return operacao.NOME_MOTORISTA.toLowerCase().includes(filterLowerCase);
            case "NOME_REDUZIDO_TRANSP":
                return operacao.NOME_REDUZIDO_TRANSP.toLowerCase().includes(filterLowerCase);
            case "PLACA_CAVALO":
                return operacao.PLACA_CAVALO.toLowerCase().includes(filterLowerCase);
            case "REFERENCIA":
                return operacao.REFERENCIA.toLowerCase().includes(filterLowerCase);
            case "NUMERO_NOTA_FISCAL":
                return operacao.NUMERO_NOTA_FISCAL && operacao.NUMERO_NOTA_FISCAL.toString().toLowerCase().includes(filterLowerCase);
            case "PLACA_CARRETA":
                return (
                    (operacao.PLACA_CARRETA && operacao.PLACA_CARRETA.toLowerCase().includes(filterLowerCase)) ||
                    (operacao.PLACA_CARRETA2 && operacao.PLACA_CARRETA2.toLowerCase().includes(filterLowerCase)) ||
                    (operacao.PLACA_CARRETA3 && operacao.PLACA_CARRETA3.toLowerCase().includes(filterLowerCase))
                );
            default:
                return true;
        }
    });

    const sendEmail = () => {
        const codOperacao = operacoes[0].COD_OPERACAO;
        Axios.post('https://portal.jc7transportes.com.br/api/carregamentos/saida/enviar-email', { COD_OPERACAO: codOperacao })
            .then(response => {
                showAlert("E-mail enviado com sucesso!", "success");
            })
            .catch(error => {
                showAlert("Erro ao enviar e-mail: " + error.message, "error");
            });
    };

    const formatKg = (n) => `${Number(n || 0).toLocaleString('pt-BR')} KG`;

    return (
        <>
            <Navbar relatorios />
            <Header />
            <Brackground />
            <Container>
                <div className={style.content}>
                    <div className={style.nav}>
                        <div className={style.navbar} onClick={() => navigate(`/relatorios`)}>
                            Selecione um navio
                        </div>
                        <div className={style.navbar} onClick={() => navigate(`/relatorios/${id}`)}>
                            Relatório de ENTRADA
                        </div>
                        <div className={style.active}>
                            Relatório de SAÍDA
                        </div>
                        <div className={style.navioNome} style={{ marginLeft: 'auto' }}>
                            {navios.map((val, idx) => (
                                <span key={idx} className={style.navioNome}>
                                    <i className="fa fa-ship icon"></i>  {val.NOME_NAVIO}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className={style.container}>

                        {/* === Resumo por DI/BL (cards responsivos) === */}
                        <section className={style.section}>
                            <div className={style.sectionHead}>
                                <i className={`fa fa-ship ${style.sectionIcon}`} />
                                <h3 className={style.sectionTitle}>Resumo por DI/BL</h3>
                            </div>

                            <div className={style.cardsGrid}>
                                {documentosENTRADA.map((d, idx) => {
                                    const manifestado = Number(d.PESO_LIQUIDO_ENTRADA || 0); // entrada = manifestado
                                    const saido = Number(d.PESO_LIQUIDO_SAIDA || 0);
                                    const saldo = manifestado - saido;
                                    const perc = manifestado > 0 ? Math.min(100, (saido / manifestado) * 100) : 0;

                                    return (
                                        <article key={idx} className={style.kpiCard}>
                                            <header className={style.cardTop}>
                                                <span className={style.badge}>DI/BL</span>
                                                <span className={style.identifier} title={d.NUMERO_DOC}>{d.NUMERO_DOC}</span>
                                                <span className={style.percentPill}>{perc.toFixed(1)}%</span>
                                            </header>

                                            <div className={style.statRow}>
                                                <span className={style.statLabel}>Manifestado</span>
                                                <span className={style.statValue}>{formatKg(manifestado)}</span>
                                            </div>
                                            <div className={style.statRow}>
                                                <span className={style.statLabel}>Descarregado</span>
                                                <span className={style.statValue}>{formatKg(saido)}</span>
                                            </div>
                                            <div className={style.statRow}>
                                                <span className={style.statLabel}>Saldo</span>
                                                <span className={`${style.statValue} ${saldo < 0 ? style.negative : ''}`}>{formatKg(saldo)}</span>
                                            </div>

                                            <div className={style.progress}>
                                                <div className={style.progressFill} style={{ width: `${perc}%` }} />
                                            </div>
                                        </article>
                                    );
                                })}
                            </div>
                        </section>

                        {/* === Resumo por Pedido (cards responsivos) === */}
                        <section className={style.section}>
                            <div className={style.sectionHead}>
                                <i className={`fa fa-clipboard-check ${style.sectionIcon}`} />
                                <h3 className={style.sectionTitle}>Resumo por Pedido</h3>
                            </div>

                            <div className={style.cardsGrid}>
                                {pedidosOp.map((p, idx) => {
                                    const manifestado = Number(p.QTDE_MANIFESTADO || 0);
                                    const saido = Number(saidoPorPedido[p.NR_PEDIDO] || 0);
                                    const saldo = manifestado - saido;
                                    const perc = manifestado > 0 ? Math.min(100, (saido / manifestado) * 100) : 0;

                                    return (
                                        <article key={idx} className={style.kpiCard}>
                                            <header className={style.cardTop}>
                                                <span className={style.badgeAlt}>Pedido</span>
                                                <span className={style.identifier} title={p.NR_PEDIDO}>{p.NR_PEDIDO} - {p.DESTINOS}</span>
                                                <span className={style.percentPill}>{perc.toFixed(1)}%</span>
                                            </header>

                                            <div className={style.statRow}>
                                                <span className={style.statLabel}>Manifestado</span>
                                                <span className={style.statValue}>{formatKg(manifestado)}</span>
                                            </div>
                                            <div className={style.statRow}>
                                                <span className={style.statLabel}>Saído</span>
                                                <span className={style.statValue}>{formatKg(saido)}</span>
                                            </div>
                                            <div className={style.statRow}>
                                                <span className={style.statLabel}>Saldo</span>
                                                <span className={`${style.statValue} ${saldo < 0 ? style.negative : ''}`}>{formatKg(saldo)}</span>
                                            </div>

                                            <div className={style.progress}>
                                                <div className={style.progressFill} style={{ width: `${perc}%` }} />
                                            </div>
                                        </article>
                                    );
                                })}
                            </div>
                        </section>


                        <section className={style.cards}>
                            <div className={style.card}>
                                <i className="fa fa-truck icon"></i>
                                <p className={style.total}><b>Carregado</b></p>
                                {autos.map((val, idx) => (
                                    <span key={idx} className={style.total}>{val.QTDE_AUTOS} Autos</span>
                                ))}
                            </div>

                            <div className={style.card}>
                                <i className="fa fa-truck icon"></i>
                                <p className={style.total}><b>Peso Líquido</b></p>
                                {pesoliquido.map((val, idx) => (
                                    <span key={idx} className={style.total}>
                                        {val.PESO_LIQUIDO ? val.PESO_LIQUIDO.toLocaleString('pt-BR') : "0"} KG
                                    </span>
                                ))}
                            </div>

                            <div className={style.card}>
                                <i className="fa fa-truck icon"></i>
                                <p className={style.total}><b>Carregado de DI</b></p>
                                {documentos.map((val, idx) => (
                                    <div key={idx} className={style.details}>
                                        <span>{val.NUMERO_DOC}</span> | {(val.PESO_LIQUIDO_DOC / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Tons | {val.QTDE_AUTOS_DOC} Autos
                                    </div>
                                ))}
                            </div>
                        </section>

                    </div>

                    <div className={style.iconcontainer}>
                        <div className={style.searchBox}>
                            <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                                <option value="NOME_MOTORISTA">Motorista</option>
                                <option value="NOME_REDUZIDO_TRANSP">Transportadora</option>
                                <option value="PLACA_CAVALO">Placa do Cavalo</option>
                                <option value="PLACA_CARRETA">Placa da Carreta</option>
                                <option value="REFERENCIA">DI/BL</option>
                                <option value="NUMERO_NOTA_FISCAL">N° Nota Fiscal</option>
                            </select>
                            <input
                                type="text"
                                placeholder="Pesquisar..."
                                value={filter}
                                onChange={handleFilterChange}
                            />
                        </div>

                        <button
                            onClick={sendEmail}
                            className={style.botaoEmail}
                        >
                            Enviar por Email
                        </button>

                        <FaFileExcel
                            onClick={() => exportToExcel(operacoes, 'RelatorioSaida')}
                            style={{ cursor: "pointer", fontSize: "1.5em", color: "green" }}
                        />
                    </div>

                    <table className={style.table}>
                        <thead>
                            <tr>
                                <th><abbr title="ID">ID</abbr></th>
                                <th><abbr title="Nome">Motorista</abbr></th>
                                <th><abbr title="Placa do Cavalo">Placa (Cavalo)</abbr></th>
                                <th><abbr title="Tara">1° Peso (TARA)</abbr></th>
                                <th><abbr title="Peso Bruto">2° Peso (BRUTO)</abbr></th>
                                <th><abbr title="Data Bruto">Data BRUTO</abbr></th>
                                <th><abbr title="Peso Líquido">Peso Líquido</abbr></th>
                                <th><abbr title="Pedido">Pedido</abbr></th>
                                <th><abbr title="Big Bags">Big Bags</abbr></th>
                                <th><abbr title="Transportadora">Transp.</abbr></th>
                                <th><abbr title="Usuário Bruto">User</abbr></th>
                                <th><abbr title="Documento">DI/BL</abbr></th>
                                <th><abbr title="PDF">PDF</abbr></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredOperacoes.map((val, index) => (
                                <tr key={index} className={
                                    val.STATUS_CARREG === 7 ? style.strikethrough :
                                        (val.PESO_BRUTO === null || val.DATA_BRUTO === null || val.USUARIO_BRUTO === null ? style.highlight : undefined)
                                }>
                                    <td>{val.ID_CARREGAMENTO}</td>
                                    <td>{formatarNomeMotorista(val.NOME_MOTORISTA)}</td>
                                    <td className={style.tooltip}>
                                        {val.PLACA_CAVALO}
                                        {(val.PLACA_CARRETA || val.PLACA_CARRETA2) && (
                                            <div className={style.tooltiptext}>
                                                Carreta 1: {val.PLACA_CARRETA || 'N/A'}<br />
                                                Carreta 2: {val.PLACA_CARRETA2 || 'N/A'}<br />
                                                Carreta 3: {val.PLACA_CARRETA3 || 'N/A'}
                                            </div>
                                        )}
                                    </td>
                                    <td>{val.PESO_TARA.toLocaleString(undefined, { maximumFractionDigits: 2 })} KG</td>
                                    <td>{val.PESO_BRUTO ? val.PESO_BRUTO.toLocaleString(undefined, { maximumFractionDigits: 2 }) + " KG" : "0 KG"}</td>
                                    <td>{moment(val.DATA_BRUTO).format('DD/MM - HH:mm')}</td>
                                    <td>{val.PESO_BRUTO && val.PESO_TARA ? (val.PESO_BRUTO - val.PESO_TARA).toLocaleString(undefined, { maximumFractionDigits: 2 }) + " KG" : "N/A"}</td>
                                    <td>{val?.NR_PEDIDO ?? '----'}</td>
                                    <td>
                                        {val.QTDA_BIG_BAG != null && val.PESO_BIG_BAG != null ? `${val.QTDA_BIG_BAG} Un - ${val.PESO_BIG_BAG.toLocaleString(undefined, { maximumFractionDigits: 2 })} KG` : ''}
                                    </td>
                                    <td>{val.NOME_REDUZIDO_TRANSP}</td>
                                    <td>{val.USUARIO_BRUTO || ''}</td>
                                    <td>{val.REFERENCIA}</td>
                                    <td>
                                        <FaFilePdf onClick={() => generatePdf(val)} style={{ cursor: "pointer" }} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Container>
        </>
    );
};

export default function IntegrationNotistack() {
    return (
        <SnackbarProvider
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            maxSnack={3}
            autoHideDuration={2500}>
            <RelatorioSaida />
        </SnackbarProvider >
    );
}
